import React, { useState } from 'react';
import DynamicSidebar from '../../../components/ui/DynamicSidebar';
import DashboardHeader from '../../../components/ui/DashboardHeader';
import Icon from '../../../components/AppIcon';

const RefundsPage = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const columns = [
    'Refund ID',
    'Transaction ID',
    'Merchant',
    'Amount',
    'Currency',
    'Reason',
    'Status',
    'Refund Date',
    'Actions',
  ];

  return (
    <div className="min-h-screen bg-background">
      <DashboardHeader onMenuToggle={() => setSidebarCollapsed(prev => !prev)} />
      <div className="flex">
        <DynamicSidebar
          isCollapsed={sidebarCollapsed}
          onToggle={() => setSidebarCollapsed(prev => !prev)}
        />
        <main
          className={`flex-1 transition-all duration-300 ${
            sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-64'
          } mt-16 p-6`}
        >
          {/* Page Header */}
          <div className="mb-6">
            <div className="flex items-center space-x-2 text-sm text-text-secondary mb-1">
              <span>Payment Operations</span>
              <Icon name="ChevronRight" size={14} />
              <span className="text-text-primary font-medium">Refunds</span>
            </div>
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-2xl font-bold text-text-primary">Refunds</h1>
                <p className="text-text-secondary text-sm mt-1">Track and manage all refund requests and processing</p>
              </div>
              <button className="flex items-center space-x-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition-smooth">
                <Icon name="Download" size={16} />
                <span>Export</span>
              </button>
            </div>
          </div>

          {/* Filters */}
          <div className="bg-surface border border-border rounded-xl p-4 mb-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              <div>
                <label className="block text-xs font-medium text-text-secondary mb-1">Transaction ID</label>
                <input
                  type="text"
                  placeholder="Search by transaction..."
                  className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background text-text-primary placeholder-text-secondary focus:outline-none focus:ring-2 focus:ring-primary/30"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-text-secondary mb-1">Status</label>
                <select className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background text-text-primary focus:outline-none focus:ring-2 focus:ring-primary/30">
                  <option value="">All Statuses</option>
                  <option value="pending">Pending</option>
                  <option value="approved">Approved</option>
                  <option value="rejected">Rejected</option>
                  <option value="processed">Processed</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-text-secondary mb-1">Start Date</label>
                <input
                  type="date"
                  className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background text-text-primary focus:outline-none focus:ring-2 focus:ring-primary/30"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-text-secondary mb-1">End Date</label>
                <input
                  type="date"
                  className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background text-text-primary focus:outline-none focus:ring-2 focus:ring-primary/30"
                />
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="bg-surface border border-border rounded-xl overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-border bg-muted/30">
                    {columns?.map(col => (
                      <th key={col} className="px-4 py-3 text-left text-xs font-semibold text-text-secondary uppercase tracking-wider">
                        {col}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={columns?.length} className="px-4 py-16 text-center">
                      <div className="flex flex-col items-center space-y-3">
                        <div className="w-12 h-12 bg-muted rounded-full flex items-center justify-center">
                          <Icon name="RotateCcw" size={24} className="text-text-secondary" />
                        </div>
                        <p className="text-text-secondary text-sm">No refunds found</p>
                        <p className="text-text-secondary text-xs">Refund data will appear here once the API is connected</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* Pagination placeholder */}
            <div className="px-4 py-3 border-t border-border flex items-center justify-between">
              <p className="text-xs text-text-secondary">Showing 0 results</p>
              <div className="flex items-center space-x-2">
                <button disabled className="px-3 py-1 text-xs border border-border rounded-lg text-text-secondary disabled:opacity-40">
                  Previous
                </button>
                <button disabled className="px-3 py-1 text-xs border border-border rounded-lg text-text-secondary disabled:opacity-40">
                  Next
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default RefundsPage;
